<template>
	<div class="order-detail" v-show="loaded">
		<div class="shai_colourbar"><img src="/static/img/shai_colourbar.png"></div>
		<div class="shai_box">
			<div class="content">
				<div class="inner_logo">
					<img src="/static/img/shai_logo.png">
				</div>
				<div class="name">{{ order.product_pkg_title }}</div>
				<div class="price">￥ <span>{{ price[0] }}</span> {{ price[1] }}</div>
			</div>
			<div class="list">
				<div>
					客户姓名<span class="ml15 black">{{ name_mask }}</span>
				</div>
				<div>
					<span class="letter">咨询顾问</span><span class="ml15 black">{{ order.staff_user_name }}（{{ order.staff_dept_name }}）</span>
				</div>
				<div>
					支付方式<span class="ml15">{{ order.paid_vendor_title }}</span>
				</div>
				<div>
					付款时间<span class="ml15">{{ order.paid_time }}</span>
				</div>
				<div>
					订单编号<span class="ml15">{{ order.order_no }}</span>
				</div>
				<div class="divider-line"></div>				
			</div>
			<div class="bottom" v-if="tips.length > 0">
				<div>温馨提示</div>
				<div>{{ tips }}</div>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MessageShow',
	data: () => ({
		'order': {},
		'customer': {},
		'share': {},
		'loaded': false,
		'tips': '',
		'name_mask': null,
		'price': ['0', '00']
	}),
	computed: {
	},
	created () {
		this.loadDetail()
	},
	components: {
	},
	mounted: function () {
		this.setPageTitle('晒单')
	},
	methods: {
		setNameMask () {
			let name = this.order.customer_name
			if (name.length === 2) {
				name = name.substring(0, 1) + '*'
			} else {
				name = name.substring(0, name.length - 2) + '**'
			}
			this.name_mask = name
		},
		loadDetail () {
			this.loading('正在读取订单信息...')
			this.getMessageDetail(this.$route.params.id, 'show', rs => {
				this.order = rs.order
				this.customer = rs.customer
				this.price = this.order.paid_price.split('.')
				if (this.price[0] > 0 || this.price[1] > 0) {
					this.price[1] = '.' + this.price[1]
				} else {
					this.price[0] = '签约成功'
					this.price[1] = ' ￥'
				}
				this.setNameMask()
				this.loaded = true
				if (this.order.is_trans && !this.order.has_signed) {
					this.tips = '财务已审核，请尽快通知客户签订电子合同'
				} else if (!this.order.is_trans && !this.order.has_signed) {
					this.tips = '支付已完成，请协助客户签订电子合同'
				} else if (this.order.service_status === 1) {
					this.tips = '订单已完成，服务已成功开通'
				} else if (this.order.has_signed) {
					this.tips = '已签订合同'
				} else if (this.order.has_survey) {
					this.tips = '已完成问卷'
				}
			})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/message/MessageShow.vue